import { Button, Form, Row } from 'antd';
import * as React from 'react';

interface SubmitButtonProps {
  loading?: boolean;
  disabled?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ loading, disabled }) => (
  <Row justify='center'>
    <Form.Item shouldUpdate>
      {({ isFieldsTouched }) => (
        <Button
          htmlType='submit'
          type='primary'
          loading={loading}
          disabled={!isFieldsTouched || disabled}
        >
          Submit
        </Button>
      )}
    </Form.Item>
  </Row>
);

export default SubmitButton;
